<div [ngClass]="{'page-editor':!viewOnly,'page-store':viewOnly}">

  <div class="pe-settings" id="editPropPanel" *ngIf="!viewOnly" data-step="3"
       data-intro='<strong>Edit component</strong> properties panel to modify Color, Heading and Text Description etc.' data-position='auto'>
      <span class="fa fa-arrow-left pe-s-backPage" *ngIf="displaySetting != 'PAGE'" (click)="displaySetting= 'PAGE'"></span>
      <app-text-setting *ngIf="displaySetting=== 'TEXT'" [item]="pageContent[itemIndexSelected]" [layoutSetting]="layoutSettings"></app-text-setting>
      <app-page-setting  *ngIf="displaySetting=== 'PAGE'" [layoutSettings]="layoutSettings"></app-page-setting>
      <app-header-setting *ngIf="displaySetting ==='HEADER'" [header]="layoutSettings.header"></app-header-setting>
      <app-footer-setting *ngIf="displaySetting === 'FOOTER'"
                          [socialLink]="socialLinks"
                          [footer]="layoutSettings.footer"></app-footer-setting>
      <app-cta-setting *ngIf="displaySetting === 'CTA'" [item]="pageContent[itemIndexSelected]" [layoutSetting]="layoutSettings"></app-cta-setting>
      <app-alert-setting *ngIf="displaySetting === 'ALERT'" [item]="pageContent[itemIndexSelected]" [layoutSetting]="layoutSettings"></app-alert-setting>
      <app-featured-products-setting *ngIf="displaySetting === 'FEATURED-PRODUCTS'" [storeName]="storeName" [layoutSetting]="layoutSettings" [item]="pageContent[itemIndexSelected]"></app-featured-products-setting>
      <app-slider-setting *ngIf="displaySetting === 'SLIDER'" [item]="pageContent[itemIndexSelected]" [layoutSetting]="layoutSettings"></app-slider-setting>
      <app-testimonial-setting *ngIf="displaySetting === 'TESTIMONIAL'" [item]="pageContent[itemIndexSelected]" [layoutSetting]="layoutSettings"></app-testimonial-setting>
      <app-countdown-setting *ngIf="displaySetting==='COUNTDOWN'" [layoutSetting]="layoutSettings" [item]="pageContent[itemIndexSelected]"></app-countdown-setting>
      <app-video-setting *ngIf="displaySetting==='VIDEO'" [layoutSetting]="layoutSettings" [item]="pageContent[itemIndexSelected]"></app-video-setting>   
  </div>
  <div class="pe-page-content">
    <app-header [layoutSetting]="layoutSettings" [header]="layoutSettings.header" class="pe-header">
      <button mat-mini-fab class="pe-pa-editor blackButton" color="accent" (click)="displaySetting = 'HEADER'" *ngIf="!viewOnly"><i class="fa fa-pencil" aria-hidden="true"></i></button>
    </app-header>
    <div data-step="2" data-intro="Components are added here which can be modified using <strong>Edit, Move and Remove</strong> buttons." data-position='top' cdkDropList (cdkDropListDropped)="drop($event)" class="pe-p-container">
      <div *ngFor=" let item of pageContent;index as itemIndex" cdkDrag
           class="pe-pa-component">
        <button *ngIf="!viewOnly" mat-mini-fab class="pe-pa-move blackButton" cdkDragHandle color="accent">
          <i class="fa fa-arrows" aria-hidden="true"></i>
        </button>
        <button *ngIf="!viewOnly" mat-mini-fab class="pe-pa-editor blackButton" (click)="selectItem(itemIndex,item.type)" color="accent"><i class="fa fa-pencil" aria-hidden="true"></i></button>
        <button  *ngIf="!viewOnly" mat-mini-fab class="pe-pa-remove blackButton" (click)="removeItem(itemIndex)" color="warn"><i class="fa fa-times" aria-hidden="true"></i></button>
        <app-alert [layoutSetting]="layoutSettings" [item]="item" *ngIf="item.type === 'ALERT'"></app-alert>
        <app-countdown [layoutSetting]="layoutSettings" [item]="item" *ngIf="item.type === 'COUNTDOWN'"></app-countdown>
        <app-featured-products [storeName]="storeName" [layoutSetting]="layoutSettings" [item]="item" *ngIf="item.type === 'FEATURED-PRODUCTS'"></app-featured-products>
        <app-slider [layoutSetting]="layoutSettings" [item]="item" *ngIf="item.type === 'SLIDER'"></app-slider>
        <app-tesimonial [layoutSetting]="layoutSettings" [item]="item" *ngIf="item.type === 'TESTIMONIAL'"></app-tesimonial>
        <app-text [layoutSetting]="layoutSettings" *ngIf="item.type === 'TEXT'" [EditText]="!viewOnly" [item]="item"></app-text>
        <app-cta [layoutSetting]="layoutSettings" *ngIf="item.type ==='CTA'" [item]="item"></app-cta>
        <app-video [layoutSetting]="layoutSettings" *ngIf="item.type ==='VIDEO'" [item]="item"></app-video>
      </div>
    </div>
    <app-footer [linksSocial]="socialLinks"
                [layoutSetting]="layoutSettings"
                [footer]="layoutSettings.footer"
                [logo]="layoutSettings.header.logo" class="pe-footer">
      <button mat-mini-fab class="pe-pa-editor blackButton" color="accent" (click)="displaySetting = 'FOOTER'" *ngIf="!viewOnly"><i class="fa fa-pencil" aria-hidden="true"></i></button>
    </app-footer>

    <div class="bottom-button" data-step="1" data-intro="<strong>Add</strong> components to your store design and then <strong>View</strong> or <strong>Save</strong> it.<br/><br/><small>*Keep saving your work to prevent loss of design!</small>" data-position="top">
      <button mat-raised-button color="accent" (click)="displayListComponent=true" class="pe-pa-addComponent blackButton" *ngIf="!viewOnly">Add Component</button>
      <a mat-raised-button color="warn" class="pe-pa-viewOnlyBtn myCustomcss blackButton" target="_blank" [routerLink]="[ '/superadmin/store-editor', editStoreId,'view' ]" *ngIf="!viewOnly && IsSuperAdmin">View</a>
      <a mat-raised-button color="warn" class="pe-pa-viewOnlyBtn myCustomcss blackButton" target="_blank" [routerLink]="[ '/store/store-editor', editStoreId,'view' ]" *ngIf="!viewOnly && !IsSuperAdmin">View</a>
      <button mat-raised-button color="primary" class="pe-pa-saveSetting blackButton" appPreventDoubleClick (debounceClick)="updateDesignSetting()" [debounceTime]="1000" *ngIf="!viewOnly">Save</button>
    </div>
  </div>
  <div class="pe-addingComponents" *ngIf="!viewOnly" [ngStyle]="{ display:displayListComponent?'block':'none'}">

    <div class="pe-co-title">
      List Component
      <span class="fa fa-times close-component" (click)="displayListComponent=false"></span>
    </div>
    <div class="pe-co-block" (click)="addItem('TEXT')">
      <img src="/assets/img/components-thumbnail/text.svg" />
      <div class="pe-co-bl-text">Text Block</div>
    </div>
    <div class="pe-co-block" (click)="addItem('CTA')">
      <img src="/assets/img/components-thumbnail/CTA.svg" />
      <div class="pe-co-bl-text">Call to Action</div>
    </div>
    <div class="pe-co-block" (click)="addItem('COUNTDOWN')">

      <img src="/assets/img/components-thumbnail/countdown.svg" />
      <div class="pe-co-bl-text">CountDown</div>
    </div>
    <div class="pe-co-block" (click)="addItem('SLIDER')">
      <img src="/assets/img/components-thumbnail/slider.svg" />
      <div class="pe-co-bl-text">Slider</div>
    </div>
    <div class="pe-co-block" (click)="addItem('TESTIMONIAL')">

      <img src="/assets/img/components-thumbnail/testimonials.svg" />
      <div class="pe-co-bl-text">Testimonial</div>
    </div>
    <div class="pe-co-block" (click)="addItem('ALERT')">
      <img src="/assets/img/components-thumbnail/bar.svg" />
      <div class="pe-co-bl-text">Alert</div>
    </div>
    <div class="pe-co-block" (click)="addItem('FEATURED-PRODUCTS')">
      <img src="/assets/img/components-thumbnail/products.svg" />
      <div class="pe-co-bl-text">Featured Products</div>
    </div>
    <div class="pe-co-block" (click)="addItem('VIDEO')">
      <img src="/assets/img/components-thumbnail/products.svg" />
      <div class="pe-co-bl-text">Video</div>
    </div>
  </div>
</div>
